import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Home, ArrowLeft, Compass } from "lucide-react";
import { LogoMark } from "@/components/Logo";

export default function NotFoundPage() {
  return (
    <div
      className="min-h-screen bg-gradient-to-b from-teal-50/40 to-white flex flex-col"
      data-testid="not-found-page"
    >
      <header className="max-w-6xl w-full mx-auto px-6 py-6">
        <Link to="/" className="flex items-center gap-2" data-testid="notfound-home-link">
          <LogoMark className="h-9" />
          <span className="font-heading font-bold text-lg tracking-tight">Gestimmony</span>
        </Link>
      </header>

      <main className="flex-1 flex items-center justify-center px-6 pb-16">
        <div className="text-center max-w-md">
          <div className="mx-auto h-16 w-16 rounded-2xl bg-teal-100 flex items-center justify-center mb-6">
            <Compass className="h-8 w-8 text-teal-700" />
          </div>
          <p className="font-heading text-6xl sm:text-7xl font-bold text-teal-700 tracking-tight">404</p>
          <h1 className="mt-4 font-heading text-2xl font-bold text-slate-900">
            Cette page n'existe pas
          </h1>
          <p className="mt-2 text-sm text-slate-500">
            Le lien que vous avez suivi est peut-être incorrect, ou la page a été déplacée.
          </p>
          <div className="mt-8 flex items-center justify-center gap-3 flex-wrap">
            <Link to="/">
              <Button variant="outline" data-testid="notfound-back-home">
                <ArrowLeft className="h-4 w-4 mr-2" /> Retour à l'accueil
              </Button>
            </Link>
            <Link to="/app">
              <Button className="bg-[hsl(var(--primary))]" data-testid="notfound-dashboard">
                <Home className="h-4 w-4 mr-2" /> Mon espace
              </Button>
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
}
